import React, { useEffect } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import transparency from "../../../Assets/Transparency.jpeg";
import "../../Informations/Information.css";
const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <div className="page-main-container-aboutus">
        <div className="business-price-numbs">
          <div className="nill-img-text-hone">
            {/* <div className='nill-img-aboutus'>
                            <img src={transparency} alt="" />
                        </div> */}
            <div className="pp-main-headings">
              <h2 className="htwo-heading-aboutus">
                Privacy Policy for NIL-Collab
              </h2>
              <p className="text-aboutus">
                NIL-Collab (“Company”) is committed to protecting your privacy.
                This Privacy Policy explains how the company collects, uses,
                discloses, and safeguards your information when you visit the
                website, mobile application, or interact with services that
                support student-athletes, fans, brands, and NIL-related
                activity.
              </p>
              <p className="text-aboutus">
                Please read this policy carefully to understand how your
                personal data is handled. If you do not agree with the terms,
                please discontinue use of the platform.
              </p>
            </div>
          </div>
          <div className="program-benefits-aboutus">
            <div className="point-box-ppolicy">
              <h2 className="pp-heading"> 1. Information We Collect</h2>
              <p className="text-aboutus">
                NIL-Collab may collect personal and non-personal information
                either directly from you or automatically through your
                interaction with the platform.
              </p>
              <h3 className="sub-text-ppolicy">A. Information You Provide</h3>
              <p className="text-aboutus-new">
                This includes information submitted when you:
              </p>
              <ul className="nil-support-services-added">
                <li>Create an account</li>
                <li>Engage in athlete collaborations or NIL activities</li>
                <li>Participate in campaigns, promotions, or events</li>
                <li>Request services or platform features</li>
                <li>Sign up for notifications or newsletters</li>
                <li>Communicate with support or submit feedback</li>
              </ul>
              <p className="text-aboutus-new" style={{ fontWeight: "bold" }}>
                Information you may provide includes:
              </p>
              <ul className="nil-support-services-added">
                <li>Full name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Billing and mailing address</li>
                <li>
                  Payment details (processed securely through third-party
                  providers)
                </li>
                <li>Affiliated school, sport, or athlete</li>
                <li>Social media profiles (if shared)</li>
                <li>Optional messages, notes, or communication preferences</li>
              </ul>
              <h3 className="sub-text-ppolicy">
                B. Information Collected Automatically
              </h3>
              <p className="text-aboutus-new">
                When using NIL-Collab, the company may automatically collect:
              </p>
              <ul className="nil-support-services-added">
                <li>IP address</li>
                <li>Device type, operating system, and model</li>
                <li>Browser type and language</li>
                <li>Access dates, times, and duration</li>
                <li>Pages viewed and interaction patterns</li>
                <li>Referring source or website</li>
                <li>Approximate location (via IP or GPS, with consent)</li>
                <li>Clickstream and navigation behavior</li>
              </ul>
              <h3 className="sub-text-ppolicy">
                C. Cookies and Tracking Technologies
              </h3>
              <p className="text-aboutus-new">
                NIL-Collab uses cookies, pixels, and similar technologies to:
              </p>
              <ul className="nil-support-services-added">
                <li>Remember preferences</li>
                <li>Enable secure login sessions</li>
                <li>Analyze platform performance and usage</li>
                <li>Improve site functionality and user experience</li>
                <li>
                  Deliver relevant content or marketing (where applicable)
                </li>
              </ul>
              <p className="text-aboutus">
                You may disable cookies through your browser settings, though
                some features may not function properly
              </p>
            </div>

            {/* ..............................  */}
            <div className="point-box-ppolicy">
              <h2 className="pp-heading">2. How We Use Your Information</h2>
              <p className="text-aboutus-new">
                Information collected may be used to:
              </p>
              <ul className="nil-support-services-added">
                <li>Provide and maintain NIL-Collab services</li>
                <li>
                  Support NIL activities, collaborations, and user interactions
                </li>
                <li>
                  Personalize user experiences and deliver tailored content
                </li>
                <li>
                  Communicate about accounts, platform activity, or service
                  updates
                </li>
                <li>Process secure payments and transactions</li>
                <li>Improve site performance, analytics, and development</li>
                <li>
                  Conduct marketing or promotional efforts (with opt-out
                  options)
                </li>
                <li>
                  Detect, prevent, or address fraud and unauthorized activity
                </li>
                <li>Comply with legal requirements</li>
              </ul>
              <p className="text-aboutus">
                Aggregated or anonymized data may be used for analytics,
                reporting, and research.
              </p>
            </div>

            {/* ..............................  */}
            <div className="point-box-ppolicy">
              <h2 className="pp-heading"> 3. How We Share Your Information</h2>
              <p className="text-aboutus-new">
                NIL-Collab does not sell your personal information. Information
                may be shared in the following circumstances:
              </p>
              <h3 className="sub-text-ppolicy">A. Service Providers</h3>
              <p className="text-aboutus-new">
                Trusted third-party vendors may assist with:
              </p>
              <ul className="nil-support-services-added">
                <li>Secure payment processing</li>
                <li>Email or communication services</li>
                <li>Cloud hosting and data storage</li>
                <li>Analytics and performance tracking</li>
                <li>Customer support</li>
              </ul>
              <p className="text-aboutus-new">
                These parties may only use data as needed to perform contracted
                services.
              </p>
              <h3 className="sub-text-ppolicy">
                B. With Athletes, Fans, or Brands
              </h3>
              <p className="text-aboutus-new">
                If you choose to participate in NIL activities, campaigns, or
                collaborations, the company may share:
              </p>
              <ul className="nil-support-services-added">
                <li>Your name</li>
                <li>Contact details (if you choose to disclose them)</li>
                <li>Information necessary for the related NIL engagement</li>
              </ul>
              <h3 className="sub-text-ppolicy">
                C. Legal and Compliance Purposes
              </h3>
              <p className="text-aboutus-new">
                Information may be disclosed when necessary to:
              </p>
              <ul className="nil-support-services-added">
                <li>Comply with legal obligations</li>
                <li>Respond to government or regulatory requests</li>
                <li>Enforce the platform’s Terms of Service</li>
                <li>Investigate potential violations or fraudulent activity</li>
                <li>Protect the rights or safety of users</li>
              </ul>
              <h3 className="sub-text-ppolicy">D. Business Transfers</h3>
              <p className="text-aboutus">
                If NIL-Collab undergoes a merger, acquisition, restructuring, or
                asset sale, relevant personal information may be transferred as
                permitted by law.
              </p>
            </div>

            {/* ..............................  */}
            <div className="point-box-ppolicy">
              <h2 className="pp-heading"> 4. Data Retention</h2>
              <p className="text-aboutus-new">
                {" "}
                Personal data is retained only as long as necessary to fulfill
                the purposes outlined in this policy or to comply with legal
                requirements. Users may request deletion of their information,
                subject to retention obligations.
              </p>
            </div>

            {/* ..............................  */}
            <div className="point-box-ppolicy">
              <h2 className="pp-heading"> 5. Data Security</h2>
              <p className="text-aboutus-new">
                {" "}
                NIL-Collab implements industry-standard measures to protect your
                data, including:
              </p>
              <ul className="nil-support-services-added">
                <li>HTTPS encryption</li>
                <li>Two-factor authentication (where applicable)</li>
                <li>Role-based access controls</li>
                <li>Firewalls and intrusion monitoring</li>
                <li>Regular system reviews and security audits</li>
              </ul>
              {/* <p className="text-aboutus-new">
                No system is completely secure, and the company cannot guarantee
                absolute protection.
              </p> */}
            </div>

            {/* ..............................  */}
            <div className="point-box-ppolicy">
              <h2 className="pp-heading"> 6 Your Rights and Choices</h2>
              <p className="text-aboutus-new">
                Depending on your jurisdiction, you may have rights such as:
              </p>
              <ul className="nil-support-services-added"> 
                <li>
                  <span style={{ fontWeight: "700" }}>Access :</span> Request a
                  copy of your stored data
                </li>
                <li>
                  <span style={{ fontWeight: "700" }}>Correction :</span> Fix
                  inaccurate or incomplete information
                </li>
                <li>
                  <span style={{ fontWeight: "700" }}>Deletion :</span> Request
                  removal of personal data
                </li>
                <li>
                  <span style={{ fontWeight: "700" }}>Restriction :</span> Limit
                  certain data processing
                </li>
                <li>
                  <span style={{ fontWeight: "700" }}>Portability :</span>{" "}
                  Request your data in machine-readable format
                </li>
                <li>
                  <span style={{ fontWeight: "700" }}>Opt-Out :</span> Decline
                  marketing messages or tracking cookies
                </li>
                <li>
                  <span style={{ fontWeight: "700" }}>Withdraw Consent :</span>{" "}
                  Where applicable, revoke prior consent
                </li>
              </ul>

              {/* <p className="text-aboutus-new">
                To exercise these rights, contact: [Insert Contact Email].
              </p> */}
            </div>

            {/* ..............................  */}
            <div className="point-box-ppolicy">
              <h2 className="pp-heading"> 7. Children’s Privacy (COPPA Compliance)</h2>
              <p className="text-aboutus">
                {" "}
                NIL-Collab does not knowingly collect personal information from
                children under 13 without verified parental consent. If such
                data is discovered, it will be deleted promptly.
              </p>
            </div>

            {/* ..............................  */}
            <div className="point-box-ppolicy">
              <h2 className="pp-heading"> 8. International Data Transfers</h2>
              <p className="text-aboutus">
                Users outside the United States acknowledge that data may be
                processed in countries with different data protection laws. All
                transfers comply with applicable regulations.
              </p>
            </div>

            {/* ..............................  */}
            <div className="point-box-ppolicy">
              <h2 className="pp-heading"> 9. Third-Party Links and Services</h2>
              <p className="text-aboutus">
                The platform may contain links to external sites not operated by
                NIL-Collab. This Privacy Policy does not apply to those sites.
                Users should review the privacy practices of each third party.
              </p>
            </div>

            {/* ..............................  */}
            <div className="point-box-ppolicy">
              <h2 className="pp-heading"> 10. Changes to This Privacy Policy</h2>
              <p className="text-aboutus-new">
                {" "}
                This policy may be updated periodically to reflect changes in
                platform practices or legal requirements. Updates may be
                communicated through:
              </p>
              <ul className="nil-support-services-added">
                <li>A notice on the website</li>
                <li>Email notifications (if applicable)</li>
              </ul>
              <p className="text-aboutus-new">
                Continued use of NIL-Collab constitutes acceptance of any
                revised policies.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default PrivacyPolicy;

// import React, { useEffect } from "react";
// import Header from "../../Header/Header";
// import Footer from "../../Footer/Footer";
// import transparency from "../../../Assets/Transparency.jpeg";
// import "../../Informations/Information.css";
// const PrivacyPolicy = () => {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
//   return (
//     <>
//       <Header />
//       <div className="page-main-container-aboutus">
//         <div className="business-price-numbs">
//           <div className="nill-img-text-hone">
//             {/* <div className='nill-img-aboutus'>
//                             <img src={transparency} alt="" />
//                         </div> */}
//             <div className="pp-main-headings">
//               <h2 className="htwo-heading-aboutus">
//                 Privacy Policy for NIL-Collab
//               </h2>
//               <p className="text-aboutus">
//                 NIL-Collab (“Company,” “we,” “us,” or “our”) is committed to
//                 protecting your privacy. This Privacy Policy explains how we
//                 collect, use, disclose, and safeguard your information when you
//                 visit our website, mobile application, or engage with our
//                 services that support student-athletes and charitable giving.
//               </p>
//               <p className="text-aboutus">
//                 Please read this policy carefully to understand our views and
//                 practices regarding your personal data and how we will treat it.
//                 If you do not agree with the terms, please do not access or use
//                 our services.:
//               </p>
//             </div>
//           </div>
//           <div className="program-benefits-aboutus">
//             <div className="point-box-ppolicy">
//               <h2> 1. Information We Collect</h2>
//               <p className="text-aboutus">
//                 We may collect several types of personal and non-personal
//                 information, either directly from you or automatically through
//                 your use of NIL-Collab.
//               </p>
//               <h3 className="sub-text-ppolicy">
//                 A. Information You Provide to Us
//               </h3>
//               <p className="text-aboutus-new">
//                 This includes information that you provide when you:
//               </p>
//               <ul className="nil-support-services-added">
//                 <li>Create an account</li>
//                 <li>Make a contribution</li>
//                 <li>Collaboration</li>
//                 <li>Participate in campaigns or sponsorships</li>
//                 <li>Sign up for newsletters or notifications</li>
//                 <li>Communicate with us or provide feedback</li>
//               </ul>
//               <p className="text-aboutus-new">This may include:</p>
//               <ul className="nil-support-services-added">
//                 <li>Full name</li>
//                 <li>Email address</li>
//                 <li>Phone number</li>
//                 <li>Billing and mailing address</li>
//                 <li>
//                   Payment details (processed through a third-party payment
//                   gateway)
//                 </li>
//                 <li>Affiliated school, sport, or athlete</li>
//                 <li>Social media handles (if shared)</li>
//                 <li>Custom contribution messages or notes</li>
//               </ul>
//               <h3 className="sub-text-ppolicy">
//                 B. Information We Collect Automatically
//               </h3>
//               <p className="text-aboutus-new">
//                 When you interact with NIL-Collab, we may automatically collect:
//               </p>
//               <ul className="nil-support-services-added">
//                 <li>IP address</li>
//                 <li>Device type, model, and OS</li>
//                 <li>Browser type and language</li>
//                 <li>Access dates and times</li>
//                 <li>Pages viewed</li>
//                 <li>Referring website or source</li>
//                 <li>Location information (based on IP or GPS, with consent)</li>
//                 <li>Site navigation patterns and user interactions</li>
//               </ul>
//               <h3 className="sub-text-ppolicy">
//                 C. Cookies and Tracking Technologies
//               </h3>
//               <p className="text-aboutus-new">
//                 We use cookies, web beacons, and similar technologies to:
//               </p>
//               <ul className="nil-support-services-added">
//                 <li>Remember user preferences</li>
//                 <li>Enable account login and secure sessions</li>
//                 <li>Track site traffic and behavior for analytics</li>
//                 <li>Deliver targeted advertisements (if applicable)</li>
//               </ul>
//               <p className="text-aboutus">
//                 You can control cookies through your browser settings. However,
//                 disabling cookies may affect site functionality.
//               </p>
//             </div>

//             {/* ..............................  */}
//             <div className="point-box-ppolicy">
//               <h2>2. How We Use Your Information</h2>
//               <p className="text-aboutus-new">
//                 We use the collected data for various purposes, including to:
//               </p>
//               <ul className="nil-support-services-added">
//                 <li>Provide, operate, and maintain NIL-Collab services</li>
//                 <li>Process and track contributions</li>
//                 <li>
//                   Personalize user experiences and display relevant content
//                 </li>
//                 <li>
//                   Communicate with users about accounts, transactions, or
//                   updates
//                 </li>
//                 <li>
//                   Improve our website and mobile experience through analytics
//                 </li>
//                 <li>
//                   Conduct marketing and promotional efforts (with opt-out
//                   options)
//                 </li>
//                 <li>
//                   Protect against fraudulent, unauthorized, or illegal activity
//                 </li>
//                 <li>Comply with legal obligations and enforcement requests</li>
//               </ul>
//               <p className="text-aboutus">
//                 We may also aggregate and anonymize your information for
//                 reporting and research purposes.
//               </p>
//             </div>

//             {/* ..............................  */}
//             <div className="point-box-ppolicy">
//               <h2> 3. How We Share Your Information</h2>
//               <p className="text-aboutus-new">
//                 {" "}
//                 We do{" "}
//                 <span style={{ fontWeight: "700" }}>
//                   not sell your personal information{" "}
//                 </span>
//                 to third parties. However, we may share information in the
//                 following cases:
//               </p>
//               <h3 className="sub-text-ppolicy">A. With Service Providers</h3>
//               <p className="text-aboutus-new">
//                 We use trusted third parties for:
//               </p>
//               <ul className="nil-support-services-added">
//                 <li>Payment processing (e.g., Stripe, PayPal)</li>
//                 <li>Email marketing (e.g., Mailchimp)</li>
//                 <li>Cloud hosting</li>
//                 <li>Analytics (e.g., Google Analytics)</li>
//                 <li>Customer service</li>
//               </ul>
//               <p className="text-aboutus-new">
//                 These vendors are only authorized to use your data as necessary
//                 to perform their services.
//               </p>
//               <h3 className="sub-text-ppolicy">
//                 B. With Student-Athletes or Organizations
//               </h3>
//               <p className="text-aboutus-new">If you opt in, we may share:</p>
//               <ul className="nil-support-services-added">
//                 <li>Your name</li>
//                 <li>Contribution amount</li>
//                 <li>Custom message</li>
//                 <li>Contact information (if you choose to share it)</li>
//               </ul>
//               <h3 className="sub-text-ppolicy">
//                 C. For Legal and Compliance Purposes
//               </h3>
//               <p className="text-aboutus-new">
//                 We may disclose personal information if required by law or in
//                 good faith belief that such action is necessary to:
//               </p>
//               <ul className="nil-support-services-added">
//                 <li>Comply with legal obligations</li>
//                 <li>Enforce our Terms of Service</li>
//                 <li>Investigate potential violations or fraud</li>
//                 <li>Protect the safety and rights of users or the public</li>
//               </ul>
//               <h3 className="sub-text-ppolicy">D. Business Transfers</h3>
//               <p className="text-aboutus">
//                 In the event of a merger, acquisition, restructuring, or sale of
//                 assets, your personal data may be transferred as part of that
//                 transaction.
//               </p>
//             </div>

//             {/* ..............................  */}
//             <div className="point-box-ppolicy">
//               <h2> 4. Data Retention</h2>
//               <p className="text-aboutus-new">
//                 {" "}
//                 We retain personal information only for as long as necessary to
//                 fulfill the purposes outlined in this Privacy Policy or as
//                 required by law.
//               </p>

//               <p className="text-aboutus-new">
//                 {" "}
//                 You may request that we delete your information at any time,
//                 subject to legal retention requirements.
//               </p>
//             </div>

//             {/* ..............................  */}
//             <div className="point-box-ppolicy">
//               <h2> 5. Data Security</h2>
//               <p className="text-aboutus-new">
//                 {" "}
//                 We implement industry-standard technical and organizational
//                 measures to protect your information, including:
//               </p>
//               <ul className="nil-support-services-added">
//                 <li>HTTPS encryption</li>
//                 <li>Two-factor authentication</li>
//                 <li>Role-based access control</li>
//                 <li>Regular security audits</li>
//               </ul>
//               <p className="text-aboutus-new">
//                 While we strive to protect your data, no internet transmission
//                 or electronic storage method is 100% secure.
//               </p>
//             </div>

//             {/* ..............................  */}
//             <div className="point-box-ppolicy">
//               <h2> 6. Your Rights and Choices</h2>
//               <p className="text-aboutus-new">
//                 Depending on your location, you may have rights including:
//               </p>
//               <ul className="nil-support-services-added">
//                 <li>
//                   <span style={{ fontWeight: "700" }}>Access:</span> Request a
//                   copy of your personal data
//                 </li>
//                 <li>
//                   <span style={{ fontWeight: "700" }}>Correction:</span> Request
//                   corrections to inaccurate information
//                 </li>
//                 <li>
//                   <span style={{ fontWeight: "700" }}>Deletion:</span> Ask us to
//                   erase your personal information
//                 </li>
//                 <li>
//                   <span style={{ fontWeight: "700" }}>Restriction:</span> Limit
//                   how we process your data
//                 </li>
//                 <li>
//                   <span style={{ fontWeight: "700" }}>Portability:</span>{" "}
//                   Request a machine-readable copy of your data
//                 </li>
//                 <li>
//                   <span style={{ fontWeight: "700" }}>Opt-out:</span> Decline
//                   marketing emails and cookies
//                 </li>
//                 <li>
//                   <span style={{ fontWeight: "700" }}>Withdraw Consent:</span>{" "}
//                   Where applicable, withdraw consent at any time
//                 </li>
//               </ul>

//               <p className="text-aboutus-new">
//                 To exercise any of these rights, contact us at [Insert Contact
//                 Email]. We will respond within legally required timeframes.
//               </p>
//             </div>

//             {/* ..............................  */}
//             <div className="point-box-ppolicy">
//               <h2> 7. Children’s Privacy (COPPA Compliance)</h2>
//               <p className="text-aboutus">
//                 {" "}
//                 NIL-Collab does not knowingly collect personal information from
//                 children under the age of 13 without parental consent. If we
//                 become aware that we have inadvertently collected data from a
//                 child, we will delete such information promptly.
//               </p>
//             </div>

//             {/* ..............................  */}
//             <div className="point-box-ppolicy">
//               <h2> 8. International Data Transfers</h2>
//               <p className="text-aboutus">
//                 If you are located outside the United States, please note that
//                 your data may be processed in and transferred to countries that
//                 may not provide the same level of data protection as your home
//                 jurisdiction. We ensure such transfers comply with applicable
//                 laws.
//               </p>
//             </div>

//             {/* ..............................  */}
//             <div className="point-box-ppolicy">
//               <h2> 9. Third-Party Services and Links</h2>
//               <p className="text-aboutus">
//                 {" "}
//                 Our platform may include links to external sites or services
//                 that we do not operate. This Privacy Policy does not apply to
//                 those third parties. We encourage you to review their privacy
//                 policies separately.
//               </p>
//             </div>

//             {/* ..............................  */}
//             <div className="point-box-ppolicy">
//               <h2> 10. Changes to This Privacy Policy</h2>
//               <p className="text-aboutus-new">
//                 {" "}
//                 We may update this Privacy Policy periodically to reflect
//                 changes in our practices, legal obligations, or services. We
//                 will notify you of significant changes through:
//               </p>
//               <ul className="nil-support-services-added">
//                 <li>A notice on our website</li>
//                 <li>An email, if applicable</li>
//               </ul>
//               <p className="text-aboutus-new">
//                 Your continued use of NIL-Collab after such updates constitutes
//                 acceptance of the revised policy.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };
// export default PrivacyPolicy;
